import { useMsal } from '@azure/msal-react';
import React from 'react';
import { LoginStatusComponent } from './loginStatusComponent';

export function LoginStatus() {
    const { instance } = useMsal();
    return (
        <LoginStatusComponent
            onLogout={() => {
                instance.logout();
                instance.setActiveAccount(null);
            }}
            firstname={instance.getActiveAccount()?.name || ' '}
            lastname={instance.getActiveAccount()?.username || ' '}
        />
    );
}
